import Constants from '@/Constants';
import { ApplicationState } from '@/store';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import './styles.scss';

const OrganizationBanner: React.FC = () => {
    const {
        dynamicAttributes: { bannerActivated, hasBanner },
        organization: { orgKey },
        application: { key },
    } = useSelector((state: ApplicationState) => state.appOrganization.data);

    const bannerUrl = useMemo(() => `${Constants.ORG_BANNER.replace('%s', orgKey).replace('%s', key.toLowerCase())}?force=${Date.now()}`, [
        orgKey,
        key,
    ]);

    if (!bannerActivated || !hasBanner) {
        return null;
    }
    return (
        <div className="org-banner-whitelabel container">
            <img src={bannerUrl} />
        </div>
    );
};

export { OrganizationBanner };
